module.exports = __webpack_public_path__ + "static/media/pg.939c5c70.svg";